import type { IconData } from '@stacksjs/iconify-core'

export const circleF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 20.565c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default circleF
